import { axiosInstance } from ".."

const gatewayList = async (id) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/entity/gateway?show=1`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default gatewayList;